module.exports = __webpack_public_path__ + "static/media/chess-knight.ed4047f7.svg";